import { Injectable } from '@angular/core';
import { GenericResponse } from 'projects/Autofacets-Core/src/app/business-entities/generic-response.class';
import { BrandViewModel } from '../business-entities/brand.interface';
import { CallDealerLogEntryRequestModel } from '../business-entities/call-dealer-log-entry-requestModel';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from './../utils/urls';


@Injectable({ providedIn: 'root' })
export class SummaryDataService {

    constructor(
        private readonly dataProvider: DataService
    ) {}
    
    async getBrand(): Promise<GenericResponse<Array<BrandViewModel>>> {
        return this.dataProvider.GetAll<GenericResponse<Array<BrandViewModel>>>(Urls.GetBrands).toPromise();
    }
    callDealerLogEntry(request:CallDealerLogEntryRequestModel){
        return this.dataProvider.PostWithOutToken<any>(Urls.CallDealerLogEntry, request).toPromise();
    }
}